import global from './global';
import components from './components';
import { initDefaultSlider } from './modules/swiper/swiper.module';
import Swup from 'swup';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';

global.init();
components.init();

// Init Swup
// new Swup({
//    plugins: [new SwupScriptsPlugin(), new SwupScrollPlugin({
//        animateScroll: true
//    })]
// });

// Bind global functons to window object
window.initDefaultSlider = initDefaultSlider;
